import { useEffect, useState } from 'react';
import { message } from 'antd';
import { useRnRCommonService } from '../../service/RnRCommon.service.jsx';
import { parse } from 'src/_shared/services/utils';
import { gql } from 'graphql-tag';
import {
    REVERSE_MAPING_BADGE_TYPE,
    ICON_COMPLETE_MAP,
    BADGE_TYPE
} from '../../../RnRCommonComponent/CoreBadge/rewardsConstants.js'

const useBadgeList = (badgeType, shouldRefresh, setShouldRefresh, getMyBadge = false, currentUser, client) => {
    const [isLoading, setIsLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [badgeList, setBadgeList] = useState([]);
    const [hasMore, setHasMore] = useState(false);
    const [pageLimit] = useState(18);
    const commonAPIService = useRnRCommonService();

    const QUERY_BADGES_BY_COMPANY_ID = gql`query QueryBadgesByCompanyIdIndex($companyId: ID!, $limit: Int, $nextToken: String) {
            queryBadgesByCompanyIdIndex(companyId: $companyId, limit: $limit, nextToken: $nextToken) {
                items {
                    id
                    companyId
                    badgeTypeId
                    assignmentSSORequiredId
                    recipientPayTypeId
                    recipientSSORequiredId
                    physicalAwardActivityId
                    iconId
                    snappyGrantId
                    snappyGrant {
                        id
                        snappyCampaignId
                        name
                        description
                        costInCurrency
                    }
                    name
                    label
                    description
                    image
                    color
                    gradientColor
                    points
                    bonusPoints
                    rewardBonus
                    rewardMaxBonus
                    assignmentLimit
                    assignmentLevelId
                    recipientLevelId
                    isPreApproved
                    isRewardRequiresDate
                    visibility
                    isAssignmentSSORequired
                    isRecipientSSORequired
                    automationRule
                    externalWorkFlowId
                }
                nextToken
            }
        }`

            const fetchBadgesByCompany = async (forceRefresh = false) => {
                if (client && currentUser?.companyId) {
                    setIsLoading(true)
                    try {
                        if (forceRefresh) {
                            localStorage.removeItem(`badgeList-${badgeType}`);
                        }
                        
                        const { data, error } = await client.query({
                            query: QUERY_BADGES_BY_COMPANY_ID,
                            variables: {
                                companyId: currentUser.companyId,
                                limit: 100,
                                nextToken: null
                            },
                            fetchPolicy: 'network-only'
                        });
                        if (error) {
                            console.error('Error fetching badges by company ID:', error);
                            return;
                        }
                        
                        if (data?.queryBadgesByCompanyIdIndex?.items) {
    
                            
                            const enrichedBadges = data.queryBadgesByCompanyIdIndex.items.map(badge => {
                                const badgeType = REVERSE_MAPING_BADGE_TYPE[badge.badgeTypeId] || '';
                                
                                let iconInfo = null; 
                                if (badge.iconId) {
                                    iconInfo = ICON_COMPLETE_MAP.find(icon => icon.id === badge.iconId);
                                }
                                
                                return {
                                    ...badge,
                                    badgeType: BADGE_TYPE[badgeType],
                                    iconInfo
                                };
                            });
 
                            return {
                                code: 200,
                                badges: enrichedBadges.filter(badge => badge.badgeType === badgeType),
                            };
                        }
                    } catch (error) {
                        console.error('Exception when fetching badges by company ID:', error);
                    } finally {
                        setIsLoading(false);
                    }
                }
            };
    

    const getAllBadgeList = async (page, limit, refresh = false) => {
        try {
            setIsLoading(true);
            let response = await fetchBadgesByCompany(refresh)
            if (response?.code === 200) {
                setShouldRefresh(false);
                setBadgeList(response.badges);
                if (page > 1) {
                    const lastCache = parse(localStorage.getItem(`badgeList-${badgeType}`))
                    const updatedCache = [...lastCache, ...response.badges]
                    const dedupedCache = [...new Set(updatedCache)];
                    localStorage.setItem(`badgeList-${badgeType}`, JSON.stringify(dedupedCache));
                } else {
                    const dedupedCache = [...new Set(response.badges)];
                    localStorage.setItem(`badgeList-${badgeType}`, JSON.stringify(dedupedCache));
                }
            } else {
                message.error('Failed to fetch recognitions list! Try again later.');
            }
        } catch (error) {
            console.error(error);
            message.error('Failed to fetch recognitions list! Try again later.');
        } finally {
            setIsLoading(false);
        }
    };
    const getMyBadgeList = async () => {
        setIsLoading(true);
        try {
            const response = await commonAPIService.getEmployeeRewardsList({ assignmentType: 'badgeAssignment' })
            if (response?.code === 200) {
                const dedupedCache = [...new Set(response?.data?.records || [])];
                localStorage.setItem(`badgeList-myBadges`, JSON.stringify(dedupedCache));
                setBadgeList(response?.data?.records || []);
            } else {
                message.error('Failed to fetch recognitions list');
            }
        } catch (error) {
            console.error(error);
            message.error('Failed to fetch recognitions list');
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (shouldRefresh) {
            setCurrentPage(1);
            getAllBadgeList(1, pageLimit, true);
        }
    }, [shouldRefresh]);

    useEffect(() => {
        if (getMyBadge) {
            console.log('getting my badge list')
            getMyBadgeList();
        } else {
            getAllBadgeList(currentPage, pageLimit);
        }
    }, [currentPage, pageLimit, getMyBadge]);

    const fetchMoreData = () => {
        setCurrentPage(prevPage => prevPage + 1);
    };
    const cachedBadgeList = parse(localStorage.getItem(`badgeList-${getMyBadge ? "myBadges" : badgeType}`));
    return { isLoading, badgeList: badgeList.length > 0 ? badgeList : cachedBadgeList, hasMore, fetchMoreData };
};

export default useBadgeList;
